// src/stone/icons/TagLoyalty.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var TagLoyalty = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M10.293 1.293a1 1 0 0 1 1.414 0l7 7A1 1 0 0 1 19 9v2a1 1 0 1 1-2 0V9.414l-6-6-6 6V22h7a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1V9a1 1 0 0 1 .293-.707z" }),
      /* @__PURE__ */ jsx("path", { d: "M11 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0M18 14.564a3.206 3.206 0 0 1 4.064.355 3.137 3.137 0 0 1 0 4.472L18 23.406l-4.063-4.015a3.137 3.137 0 0 1 0-4.471A3.21 3.21 0 0 1 18 14.564m2.658 1.778a1.2 1.2 0 0 0-1.828.18L18 17.757l-.83-1.235a1.2 1.2 0 0 0-1.828-.18m5.316 0c.456.451.455 1.176 0 1.625L18 20.594l-2.658-2.626a1.137 1.137 0 0 1 0-1.626" })
    ]
  }
);
var TagLoyalty_default = TagLoyalty;

export {
  TagLoyalty_default
};
